
import { defineComponent, PropType, ref, watch } from 'vue'
import { useRouter } from 'vue-router'

import { Custom } from '@/types/custom'


export interface Breadcrumb {
  size?: 'small' | 'medium' | 'large'
  type: 'text' | 'link' | 'input' | 'select'
  text?: {
    name: string
    secondName?: string
  }
  link?: {
    name: string
    secondName?: string
    path?: string
  }
  input?: {
    name?: string
    path?: string
    inputName: string
  }
  select?: {
    type: 'game' | 'grouping'
    name?: string
    path?: string
    currentId: string | number
    list: any[]
  }
  setting?: {
    path: string
  }
}

export default defineComponent({
  name: 'BaseBreadcrumb',
  inheritAttrs: false,
  props: {
    breadcrumbs: {
      type: Array as PropType<Breadcrumb[]>
    }
  },
  setup(props, context) {
    const router = useRouter()

    const breadcrumbList = ref()

    watch(
      () => [props.breadcrumbs],
      () => {
        breadcrumbList.value = (props.breadcrumbs as Breadcrumb[]).map(item => ({...item}))
      },
      { immediate: true, deep: true }
    )

    const onChangeInput = (event: Event, index: number) => {
      const target = event.target as HTMLInputElement
      const value = target.value
      target.blur()

      if (value.length > 0) {
        context.emit('onChangeInput', value)
      } else {
        breadcrumbList.value[index].input.inputName = (props.breadcrumbs as Breadcrumb[])[index].input?.inputName
      }
    }

    const onChangeSelect = (index: number, type: string) => {
      if (type === 'game') {
        const custom_id = breadcrumbList.value[index].select.currentId

        router.push({ query: { custom: custom_id }})
      } else if (type === 'grouping') {
        const custom_id = breadcrumbList.value[index].select.currentId
        const custom = breadcrumbList.value[index].select.list.find((custom: Custom) => custom.id === custom_id)
        const group_id = custom.groups[0].id

        router.push({ params: { group_id: group_id } })
      } else if (type === 'appearance') {
        const mode_id = breadcrumbList.value[index].select.currentId

        router.push({ query: { mode: mode_id } })
      }
    }

    return {
      breadcrumbList,

      onChangeInput,
      onChangeSelect
    }
  }
})
